import * as tslib_1 from "tslib";
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import { getFallbackValueIfNull } from 'owa-options-core';
import { saveCalendarMailboxConfiguration } from 'owa-calendar-configuration';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
/**
 * Action called when we save the txp options
 */
export default select({
    optionState: function () { return store; },
    calendarConfiguration: function () { return getCalendarConfiguration(); },
})(action('saveTxpOption')(function saveTxpOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, calendarConfiguration;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, calendarConfiguration = state.calendarConfiguration;
                    calendarConfiguration.CreateEventsFromEmailAsPrivate = getFallbackValueIfNull(optionState.CreateEventsFromEmailAsPrivate, calendarConfiguration.CreateEventsFromEmailAsPrivate);
                    calendarConfiguration.EventsFromEmailEnabled = getFallbackValueIfNull(optionState.EventsFromEmailEnabled, calendarConfiguration.EventsFromEmailEnabled);
                    // Push the rest of the events to the mailboxConfiguration
                    Object.keys(optionState.Events).map(function (eventType) {
                        var val = getFallbackValueIfNull(optionState.Events[eventType], calendarConfiguration[eventType]);
                        calendarConfiguration[eventType] = val;
                    });
                    return [4 /*yield*/, saveCalendarMailboxConfiguration(calendarConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveTxpOption.js.map